import { FileText, Image as ImageIcon, Download, Trash2 } from 'lucide-react';

interface MediaListItemProps {
  id: number;
  name: string;
  size: number;
  createdAt: string;
  type: 'document' | 'image';
  onDownload: (id: number, name: string, type: string) => void;
  onDelete: (id: number) => void;
  isDeleting: boolean;
  canDelete?: boolean;
}

const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

export const MediaListItem = ({
  id,
  name,
  size,
  createdAt,
  type,
  onDownload,
  onDelete,
  isDeleting,
  canDelete = true,
}: MediaListItemProps) => {
  const Icon = type === 'document' ? FileText : ImageIcon;
  const iconColor = type === 'document' ? 'text-blue-600' : 'text-green-600';
  const modelType = type === 'document' ? 'documents' : 'images';

  return (
    <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 border border-transparent dark:border-gray-700 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
      <div className="flex items-center gap-3">
        <Icon className={`w-5 h-5 ${iconColor}`} />
        <div>
          <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{name}</p>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {formatFileSize(size)} • {new Date(createdAt).toLocaleDateString()}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onDownload(id, name, modelType)}
          className="text-blue-600 hover:text-blue-800 transition-colors"
          title="Download"
        >
          <Download className="w-4 h-4" />
        </button>
        {canDelete && (
          <button
            type="button"
            onClick={() => onDelete(id)}
            className="text-red-600 hover:text-red-800 transition-colors"
            title="Delete"
            disabled={isDeleting}
          >
            <Trash2 className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};
